<template>
    <div class="notifications">
        <div class="container">
            <transition-group name="list" mode="in-out" tag="article">
                <article
                    class="alert alert-dismissible"
                    role="alert"
                    v-for="(notification, id) in notifications"
                    v-bind:key="`md-toast-${id}`"
                    :class="`alert-${notification.type}`"
                    @click="removeNotification(notification)"
                >
                    <a-icon
                        v-if="notification.type !== 'success'"
                        class="mr-2"
                        icon="Warning"
                    />
                    <a-icon v-else class="mr-2" icon="Success" />
                    <span
                        v-if="typeof notification.content === 'string'"
                        :class="notificationClass(notification)"
                        v-html="notification.content"
                    ></span>
                    <span
                        v-else-if="typeof notification.content === 'object'"
                        :class="notificationClass(notification)"
                    >
                        <component
                            v-bind:is="notification.content.component"
                        ></component>
                    </span>
                    <button
                        type="button"
                        class="close"
                        :class="notificationClass(notification)"
                        data-dismiss="alert"
                        aria-label="Close"
                        @click="removeNotification(notification)"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </article>
            </transition-group>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        notifications() {
            return this.$store.getters.notifications
        }
    },
    methods: {
        removeNotification(notification) {
            this.$store.dispatch('removeNotification', notification.id)
        },
        notificationClass(notification) {
            return notification.type !== 'danger' ? 'text-dark' : ''
        }
    }
}
</script>

<style lang="scss">
.notifications {
    position: fixed;
    left: 1.5rem;
    top: 1.5rem;
    width: calc(100% - 3rem);
    z-index: var(--z-index-notification);
    .alert-dismissible {
        display: flex;
        align-items: flex-start;
        padding-right: 3.5rem;
        .a-icon {
            min-width: 24px;
        }
    }
}
</style>
